/*
 * @Author: your name
 * @Date: 2021-01-15 10:06:47
 * @LastEditTime: 2021-10-28 10:23:15
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \dy-sfc-h5\src\utils\constant.js
 */
const color = {
  primary: '#FF7307',
  white: '#fff'
}

const eimitTypes = {
  SELECT_ORDER: 'select_order'
}

const wordOrder = {
  processing: '处理中',
  ok: '已处理',
  appeal: '申诉中',
  appeal_ok: '申诉完成',
  confirm: '判责中',
  confirm_ok: '判责完成'
}
const USER_STATUS = {
  processing: '处理中',
  ok: '处理完成',
  duty_ok: '追责完成',
  duty_in: '追责中',
  duty_no: '放弃追责',
  confirm: '确认追责'
}

// 客服电话
const KF_PHONE = '087168888889'
const WX_ORIGIN_ID = 'gh_418157cdd62a'

/**
 * 易宝支付类型
 */
const YB_PAY_TYPES = {
  YB_ALIPAY_USER_SCAN: 'YB_ALIPAY_USER_SCAN', // 支付宝支付参数
  YB_WECHAT_USER_SCAN: 'YB_WECHAT_USER_SCAN', // 微信支付参数
  YB_WECHAT_OFFIACCOUNT: 'YB_WECHAT_OFFIACCOUNT' // 微信公众号支付参数
}

module.exports = {
  color,
  eimitTypes,
  wordOrder,
  KF_PHONE,
  USER_STATUS,
  WX_ORIGIN_ID,
  YB_PAY_TYPES
}
